export function getCurrency(payment) {
  return payment.multiContainerInvoice?.supplier?.bankAccount.find(
    (account) =>
      account.id === payment?.multiContainerInvoice?.supplierBankAccountId
  )?.accountCurrency;
}